<script lang="ts">
  import posthog from "posthog-js";
  import { ENV } from "$lib/util/env";
  import "../app.css";
  import { injectSpeedInsights } from "@vercel/speed-insights/sveltekit";
  import { ClerkLoaded, ClerkProvider } from "svelte-clerk";
  import { browser } from "$app/environment";
  import { page } from "$app/state";

  injectSpeedInsights();

  const { children } = $props();

  if (browser && ENV.VITE_POSTHOG_KEY && ENV.VITE_POSTHOG_HOST) {
    posthog.init(ENV.VITE_POSTHOG_KEY, {
      api_host: ENV.VITE_POSTHOG_HOST,
    });
  }
</script>

<ClerkProvider publishableKey={ENV.VITE_CLERK_PUBLISHABLE_KEY}>
  {#if page.url.pathname === "/"}
    {@render children?.()}
  {:else}
    <ClerkLoaded>
      {@render children?.()}
    </ClerkLoaded>
  {/if}
</ClerkProvider>
